import type { EFinancingProgram, SystemFlowConfiguration } from '@if/core/types'
import { createContext, useContext } from 'react'

export type SystemFlowConfig = Partial<Record<EFinancingProgram, SystemFlowConfiguration>>

export const SystemFlowContext = createContext<SystemFlowConfig | null>(null)

export function useSystemFlowConfig(): SystemFlowConfig {
  const context = useContext(SystemFlowContext)
  if (!context) {
    throw new Error('useSystemFlowConfig must be used within a SystemFlowProvider')
  }
  return context
}
